(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.colors);
    global.SplitButtonMenuItemStyles = mod.exports;
  }
})(this, function (exports, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SplitButtonMenuItemCss = {
    root: {
      color: _colors2.default.prussian,
      fontSize: '13px',
      fontFamily: 'Proxima Nova, Helvetica, sans-serif',
      padding: '5px 28px 5px 28px'
    }
  };

  exports.default = SplitButtonMenuItemCss;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/SplitButton/SplitButtonMenuItem.styles.js
// module id = 1945
// module chunks = 1